import API from '../../../helpers/api';

import CLIENT from '../actionTypes';

import { AppDispatch, GetState } from '../../../types/app';

export const load = () => async (dispatch: AppDispatch) => {
  dispatch({ type: CLIENT.TOTAL_BALANCE.REQUESTING });

  // USD
  const currencyId = 23;

  try {
    const { balance } = await API.callGraphQL<{ balance: number }>(
      `
      query ($currencyId: Int!) {
        balance: clientTotalBalance(CurrencyId: $currencyId)
      }
    `,
      { currencyId }
    );

    dispatch({ type: CLIENT.TOTAL_BALANCE.SUCCESS, data: balance });
  } catch (err) {
    dispatch({ type: CLIENT.TOTAL_BALANCE.FAILURE, err: err.message });
  }
};

export const loadIfNeeded =
  () => async (dispatch: AppDispatch, getState: GetState) => {
    const { Client, ClientTotalBalance } = getState();

    if (
      Client.isLoggedIn &&
      ClientTotalBalance.readyStatus === CLIENT.TOTAL_BALANCE.INVALID
    ) {
      await dispatch(load());
    }
  };
